export const MIN_PHONE_LENGTH = 6;

/**
 * max phone length
 */
export const MAX_PHONE_LENGTH = 15;

/**
 * min password length
 */
export const MIN_PASSWORD_LENGTH = 6;

/**
 * max password length
 */
export const MAX_PASSWORD_LENGTH = 255;
